export default __webpack_public_path__ + "static/media/manageItemsIcon.3b46d045.svg";